import { render } from "./UpdateTinInfoView.vue?vue&type=template&id=44b61452"
import script from "./UpdateTinInfoView.vue?vue&type=script&lang=js"
export * from "./UpdateTinInfoView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__